export default {
  "Snackbar.Success": "登録を受付けました\n適用には数日かかる場合があります",
  // 未使用
  "Snackbar.Error":
    "サーバーとの通信に失敗しました\nページが表示できませんでした",
}
